const separators = [
  '\\(',
  '\\)',
  ',',
  '=',
  '>',
  '<',
  '>=',
  '<=',
  '\\+',
  '\\-',
  '\\*',
  '\\/',
  '\\^',
];

// All strings start with ' in the expression editor.
// So that can be used to identify text instead of a valid expression.
// Example: 'Hello World'
export const IS_STRING = /[']/;

export const SEPARATOR_REGEX = separators.join('|');

export function splitBySeparators(string) {
  return string.split(new RegExp(SEPARATOR_REGEX, 'g'));
}

// Matches any string expression
//
// Example:
//     Input: SUM(10, LENGTH("Hello"))
//                           ^^^^^^^
export const STRINGS_REGEX = /".*?"/g;

// Matches field names in a expression
// Note: This only work correctly if strings are removed of the expression
// Note: The field identifier is in the last captured group, please don't take the whole match
//
// Example:
//     Input: SUM(1,SUM(2,SUM,SUM(1,2),_100, _, Group/Integer_Input, 1.5))
//                        ^^^          ^^^^  ^  ^^^^^^^^^^^^^^^^^^^
// Explanation:
//     * Should be preceded by any separator, start of line, with an optional space
//     * Should start with an alphabetical character, an underscore
//     * After that, can contain 0 or more alphabetical characters, underscores, integers, or slashes
//     * Can't be followed by an opening parethesis "(" because in that case it is a function
export const ANY_FIELD_IDENTIFIER_REGEX = new RegExp(
  `(?:(^|\\(|${SEPARATOR_REGEX})\\s?)([a-zA-Z_][a-zA-Z_\\d/]*)(?!\\(|[a-zA-Z_\\d])`,
  'g'
);

// Matches field names in a expression (XML Version)
// Note: This only work correctly if strings are removed of the expression
// Note: The field identifier is in the last captured group, please don't take the whole match
//
// Example:
//     Input: SUM(1,SUM(2,../../SUM,SUM(1,2),_100, _, ../Group/Integer_Input, 1.5))
//                        ^^^^^^^^^         ^^^^  ^  ^^^^^^^^^^^^^^^^^^^^^^
// Explanation: aaa
//     * Should be preceded by any separator, start of line, with an optional space
//     * Should start with an alphabetical character, an underscore, a dot, or many "../"
//     * After that, can contain 0 or more alphabetical characters, underscores, integers, or slashes
//     * Can't be followed by an opening parethesis "(" because in that case it is a function
export const ANY_XML_FIELD_IDENTIFIER_REGEX = new RegExp(
  `(?:(?:^|${SEPARATOR_REGEX})\\s?)(((\\.\\.\\/)+|[a-zA-Z])[a-zA-Z_\\d/]*)(?!\\(|[a-zA-Z_\\d])`,
  'g'
);

/**
 * Returns a Regex to match a field identifier inside an expression
 * @param {string} identifier
 * @returns RegExp
 */
export const getSpecificFieldIdentifierRegex = (identifier) =>
  // Note: This only work correctly if strings are removed of the expression
  // Note: The field identifier is in the last captured group, please don't take the whole match
  //
  // Explanation:
  //     * The identifier can't be preceded by an alphabetic character or underscore
  //     * The identifier can be followed by any ammount of spaces
  //     * The identifier can't be followed by an opening parenthesis "("
  //     * The identifier should end with any separator, or the end of line
  new RegExp(`([^\\w]|^)(${identifier}\\s*)(?!\\()(?=[${SEPARATOR_REGEX}]|$)`);

export function escapeRegExp(string) {
  return string.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
